import { useState, useEffect, useContext, useCallback } from "react";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../components/data_table/data_table.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Stack, StackItem, TooltipHost } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Input, Tooltip, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme } from "@fluentui/react-components";
import { SquareHintApps20Regular, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, FilterAdd20Filled, PlugConnectedCheckmarkFilled, PlugConnectedCheckmark20Filled, PlugConnectedCheckmark20Regular, } from "@fluentui/react-icons";
import { SearchBox } from "@fluentui/react-search-preview";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../components/dropdown/menu.component";
import { DropdownComponent } from "../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { fullscreenIcon, primaryIcon, secondaryIcon, exitIcon, lightTheme, overflowDivider, buttonContent, DynamicBoxingCSS, SubSectionResponsive, parentHome, wraperStyle, paddingTop, dashboardTheme, BreadcrumbsBorder } from "../../styles/customStyles";
import DialogBox from "../../components/dialog/dialog.component";
import { GlobalContext } from "../../hooks/globalContext";
import { usePermissionStore } from "../../Store/permissionStore";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import { SearchBar } from "../../components/searchbar/searchbar.component";
import { ToastComponent } from "../../components/toast/toast.component";
import { checkEnabledDart, getPatchDetails, getPatchDetailsCount, getPatchMachineDetails, getPatchMachineDetailsCount, updateDart } from "../../api/patchmanagement/patchdetection_func";
import { convertUTCToHumanReadableFormat } from "../../utility/utils";
import { DatepickerComponent } from "../../components/picker/datepicker.component";
import { PatchPages } from "../../components/side_menu/InlineSidenav";


interface PatchDetails {
  ptitle: string;
  ptype: string;
  patchdesc: string;
  psize: number;
  patch_count: number;
  detectedate: string;
}


export const PatchDetection = () => {
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  const handle = useFullScreenHandle();
  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [overLayData, setOverLayData] = useState<any>({});
  const [overlayTableLoading, setOverlayTableLoading] = useState(false);
  const [overlayTableData, setOverlayTableData] = useState([]);
  const [final_overlay_data, set_final_overlay_data]: any = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [overlaySearchVal, setOverlaySearchVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [isdeletedisabled, setDeleteDisabled] = useState(false);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [isfilter, setIsFilter]: any = useState(false);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error' | 'warning'; text: string } | null>(null);
  const [errorMessage, setErrorMessage] = useState<String>('');
  const [dartErrorMessage, setDartErrorMessage] = useState<String>('');
  const [refreshing, setRefreshing] = useState(false);
  const [checkDart, setCheckDart] = useState(false);
  const [checkIsUpdatedDart, setCheckIsUpdatedDart] = useState(false);


  const [totalOverlayPages, setTotalOverlayPages] = useState(1);
  const [currentOverlayPageNo, setCurrentOverlayPageNo] = useState(1);
  const [totalOverlayRecords, setTotalOverlayRecords] = useState(0);

  const [isOverlayFilter, setIsOverlayFilter] = useState(false);
  const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
  const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
  const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
  const [overlayFilterArray, setOverlayFilterArray] = useState<string[]>([]);
  const [isOverlayResetDisabled, setOverlayResetDisabled] = useState(true);
  const [currentTitle, setCurrentTitle] = useState<string | null>(null);
  const [dart237Details, setDart237Details]: any = useState({});

  // const [permissions, setPermissions] = useState(['']);

  const { permissions } = usePermissionStore();
  console.log("checking the permissions------>", permissions)

  useEffect(() => {
    const checkDartStatus = async () => {
      setLoading(true); // Start loading when checking DART
      try {
        if (tenantName) {
          const response = await checkEnabledDart({ name: tenantName });
          setDart237Details(response.data);
          if (response.status === 'success' && response.data.valu === "1") {
            console.log("DART 237 is enabled");
            setCheckDart(true);
            // Don't set loading false here, let the data fetch handle it
          } else {
            console.log("DART 237 is not enabled");
            setCheckDart(false);
            setDartErrorMessage("DART 237 is not enabled. Please contact your administrator.");
            setLoading(false); // Stop loading since we won't fetch data
          }
        } else {
          console.log("Tenant name is not available");
          setMessage({ type: 'error', text: 'Tenant name is not available!' });
          setIsToast(true);
          setTimeout(() => {
            setIsToast(false);
          }, 3000);
        }
      } catch (error) {
        console.error("Error checking DART 237 status:", error);
        setCheckDart(false);
        setDartErrorMessage("Error checking DART 237 status. Please try again later.");
        setLoading(false);
      }
    };

    checkDartStatus();
  }, [tenantName, checkIsUpdatedDart]);

  const handleDartUpdate = async () => {
    try {
      const valueid = dart237Details?.valueid;
      const revl = dart237Details?.revl;
      if (valueid) {
        const response = await updateDart({ valueid: valueid, revl: revl, valu: checkDart ? '0' : '1', });
        if (response) {
          setCheckDart(!checkDart);
          setCheckIsUpdatedDart(!checkDart);
          setMessage({ type: 'success', text: 'Dart 237 updated successfully!' });
          setIsToast(true);
          setTimeout(() => {
            setIsToast(false);
          }, 3000);
          console.log("dart updated successfully")
        } else {
          setMessage({ type: 'error', text: 'Dart 237 update failed!' });
          setIsToast(true);
          setTimeout(() => {
            setIsToast(false);
          }, 3000);
          console.log("dart update failed")
        }
      } else {
        setMessage({ type: 'error', text: 'Wrong tenant error!' });
        setIsToast(true);
        setTimeout(() => {
          setIsToast(false);
        }, 3000);
      }
    } catch (error) {

    }
  };
  const handleOverlayFilter = (): any => {
    const value1 = dropDownValue1Overlay;
    const value2 = dropDownValue2Overlay;
    const result = value1 + " : " + value2;
    setOverlayFilterArray([...overlayFilterArray, result])
    setIsOverlayFilter(true);
    setOverlayTableLoading(true);
    setDropDownValue1Overlay('');
    setDropDownValue2Overlay('');
    if (overlayFilterArray.some((filter) => filter.startsWith(`${dropDownValue1Overlay} :`))) {
      setErrorMessage(`${dropDownValue1Overlay} is already filtered.`);
      return;
    } else {
      setErrorMessage(''); // Clear the message if no issue
    }
  }

  const handleCloseOverlayFilter = (index: any): any => {
    console.log(" handleCloseOverlayFilter clicked");
    const updatedArray = overlayFilterArray.filter((x, itemIndex) => itemIndex !== index);
    setOverlayFilterArray(updatedArray);
    setOverlayTableLoading(true);
  }

  const overlayInputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_-]*$/;
    const regexN = /^[0-9]*$/;
    if (name === 'filter' && dropDownValue1Overlay === ("Device Name") || dropDownValue1Overlay === ("Device Classification")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2Overlay(enteredValue);
      }
    }
  }

  useEffect(() => {
    setOverlayResetDisabled(overlayFilterArray.length > 0 ? false : true);
  }, [overlayFilterArray]);

  const fetchPatchDetails = useCallback(async (
    statusArray: number[],
    tenant: string,
    limit: number,
    offset: number,
    type: 'normal' | 'filter' | 'search',
    filter?: string[]
  ) => {
    try {
      const whereCondition = {
        statusArray,
        tenant,
        type,
        ...(type === 'filter' && { filter: filterArray }),
        ...(type === 'search' && { search: searchTerm })
      };

      const [countResponse, response] = await Promise.all([
        getPatchDetailsCount(whereCondition, limit, offset),
        getPatchDetails(whereCondition, limit, offset)
      ]);

      if (countResponse.status === 'success') {
        setTotalRecords(countResponse.data.totalRecords);
        setTotalPages(countResponse.data.totalPages);
      }

      if (response.status === 'success') {
        set_final_data(response.data);
      }
    } catch (error) {
      console.error("Error getting patch details:", error);
    }
  }, [filterArray, searchTerm]);

  useEffect(() => {
    const DEFAULT_STATUS = [16, 11, 6, 15, 18];
    const DEFAULT_TENANT = tenantName || 'Endeavour_Testing';
    const LIMIT = 50;
    const offset = (currentPageNo - 1) * LIMIT;

    let type: 'normal' | 'filter' | 'search' = 'normal';

    if (isfilter) {
      type = 'filter';
    } else if (searchTerm.trim() !== '') {
      type = 'search';
    }

    const fetchData = async () => {
      if (checkDart) {
        setLoading(true);
        try {
          await fetchPatchDetails(DEFAULT_STATUS, DEFAULT_TENANT, LIMIT, offset, type);
        } catch (error) {
          console.error("Error fetching patch details:", error);
          setErrorMessage("Error fetching data. Please try again later.");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchData();

    if (refreshing) {
      setRefreshing(false);
      setLoading(false);
    }
  }, [fetchPatchDetails, currentPageNo, refreshing, isfilter, searchTerm, filterArray, checkDart]);


  useEffect(() => {
    console.log('filterArray changed:', filterArray);
  }, [filterArray]);

  const handleRefresh = () => {
    setRefreshing(true);
    setRefreshToast(true);
    setLoading(true);
  };

  // const inputChange=(e:any)=>{
  //   const enteredValue =e.target.value;
  //   console.log("entered value",enteredValue)
  //   let name =e.target.name;
  //   if (name === 'filter') {
  //     setDropDownValue2(enteredValue);
  //   }
  // }
  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    console.log("entered dropDownValue1 value", dropDownValue1)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_-]*$/;
    const regexN = /^[0-9\.]*$/;
    if (name === 'filter' && dropDownValue1 === ("Patch Name")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Patch Type")) {
      if (regexN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Release date")) {
      if (regexN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
  }

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1;
    const value2 = dropDownValue2;
    // if(value1 !== undefined && value1 !== '' && value2 !== undefined && value2 !== '') {
    const result = value1 + " : " + value2;
    console.log("filterArray result : " + result);
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
    // }
  }

  const handleCloseFilter = (index: any): any => {
    console.log("clicked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setLoading(true);
  }
  const handleFilterValueSelect = (event: { target: { value: Event; }; }): void => {
    alert(event.target.value);
  }

  useEffect(() => {
    setResetDisabled(filterArray.length > 0 ? false : true);
  }, [filterArray]);
  const [response, setresponse] = useState('');
  const [isIconEnabled, setIconEnabled] = useState(false);
  const handleIconActive: any = (data: any) => {
    setIconEnabled(data.target.checked);
  }

  //data table column name code starts here
  //Patch Name, Patch Type, Patch Desc,  Patch Size, Machine Count, Release date
  var columns = [
    { key: "patchname", label: <Body1Strong>Patch Name</Body1Strong> },
    { key: "patchtype", label: <Body1Strong>Patch Type</Body1Strong> },
    { key: "patchdesc", label: <Body1Strong>Patch Desc</Body1Strong> },
    { key: "patchsize", label: <Body1Strong>Patch Size</Body1Strong> },
    { key: "machinecount", label: <Body1Strong>Machine Count</Body1Strong> },
    { key: "releasedate", label: <Body1Strong>Release date</Body1Strong> },
  ];

  //data table column name code ends here

  //filter dropdown column names starts here
  var columns1 = [
    { key: "patchname", label: <Body1Strong>Patch Name</Body1Strong> },
    { key: "patchtype", label: <Body1Strong>Patch Type</Body1Strong> },
    // { key: "patchdesc", label: <Body1Strong> Patch Desc </Body1Strong> },
    // { key: "patchsize", label: <Body1Strong> Patch Size </Body1Strong> },
    // { key: "machinecount", label: <Body1Strong> Machine Count </Body1Strong> },
    { key: "releasedate", label: <Body1Strong>Release date</Body1Strong> },
  ];

  const overlayColumns = [
    { key: "host", label: <Body1Strong>Host</Body1Strong> },
    { key: "detectedDate", label: <Body1Strong>Date</Body1Strong> },
  ]
  // overflow set contents code ends here
  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>

        <Stack tokens={{ childrenGap: 10 }} horizontal>
          <StackItem>
            <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={handleRefresh}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
                <StackItem> <Caption1> Refresh </Caption1> </StackItem>
              </Stack>
            </Button>



            {
              permissions.includes("all") || permissions.includes("patchDetection_Fullaccess") || permissions.includes("patchDetection_ReadandExport") ? (
                <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_discoceredappslist.csv`}>
                  {/* <Button shape="circular" appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem>{loading?<ArrowDownload20Regular {...secondaryIcon} />:<ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                      <StackItem> <Caption1> Export </Caption1> </StackItem>
                    </Stack>
                  </Button> */}
                </CSVLink>
              ) :
                <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                  <Button shape="circular" appearance="subtle" size="small" disabled>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem> <Caption1> Export </Caption1> </StackItem>
                    </Stack>
                  </Button>
                </Tooltip>
            }

          </StackItem>
          <StackItem>
            <DialogBox
              headerButton={
                <>
                  <Button shape="circular" appearance="subtle" size="small" disabled={loading || tableData.length === 0}>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <PlugConnectedCheckmark20Regular {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} /> </StackItem>
                      <StackItem> <Caption1> {checkDart ? `Disable Dart` : `Enable Dart`} </Caption1> </StackItem>
                    </Stack>
                  </Button>
                </>
              }

              content={`Are you sure you want to ${checkDart ? 'Disable Dart' : 'Enable Dart'}`}

              footer=
              {
                <>
                  <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <StackItem>
                      <Button shape="circular" appearance="primary" size="small" onClick={() => { handleDartUpdate(); }}>Confirm</Button>
                    </StackItem>
                    <StackItem>
                      <Button shape="circular" size="small" >Cancel</Button>
                    </StackItem>
                  </Stack>
                </>
              }
            />
          </StackItem>

        </Stack>
          <StackItem grow shrink>
              <Stack horizontalAlign="end">
                  <StackItem grow shrink>
                      <FullScreenButton handle={handle} />
                  </StackItem>
              </Stack>
          </StackItem>
      </>
    ,
  };


  const handleMachineCountClick = (title: string) => {
    setCurrentTitle(title);
    setOverlayOpen(true);
    setOverlaySearchVal('');
    setOverlayFilterArray([]);
    setIsOverlayFilter(false);
    setOverlayTableLoading(true);
  };

  const handleOverlayClose = () => {
    setOverlayOpen(false);
    setCurrentTitle(null);
    setOverlaySearchVal('');
    setOverlayFilterArray([]);
    setIsOverlayFilter(false);
  };

  const getMachineDetails = useCallback(async (
    type: 'normal' | 'filter' | 'search' = 'normal'
  ): Promise<any> => {
    if (!currentTitle) return; // Early return if no title

    setOverlayTableLoading(true);

    try {
      const whereCondition = {
        title: currentTitle,
        tenant: tenantName,
        type,
        ...(type === 'filter' && { filter: overlayFilterArray }),
        ...(type === 'search' && { search: overlaySearchVal })
      };

      const [countResponse, response] = await Promise.all([
        getPatchMachineDetailsCount(whereCondition, 50, (currentPageNo - 1) * 50),
        getPatchMachineDetails(whereCondition, 50, (currentPageNo - 1) * 50)
      ]);

      if (countResponse?.status === 'success') {
        setTotalOverlayRecords(countResponse.data.totalRecords);
        setTotalOverlayPages(countResponse.data.totalPages);
      }

      if (response?.status === 'success') {
        set_final_overlay_data(response.data);
      }
    } catch (error) {
      console.log("error getting patch details", error);
      set_final_overlay_data([]);
    } finally {
      setOverlayTableLoading(false);
    }
  }, [currentTitle, currentOverlayPageNo, overlayFilterArray, overlaySearchVal]);

  // Effect to trigger data fetching
  useEffect(() => {
    if (!overlayOpen || !currentTitle) return;

    let type: 'normal' | 'filter' | 'search' = 'normal';

    if (isOverlayFilter) {
      type = 'filter';
    } else if (overlaySearchVal.trim() !== '') {
      type = 'search';
    }

    getMachineDetails(type);
  }, [
    getMachineDetails,
    overlayOpen,
    currentTitle,
    overlayFilterArray,
    isOverlayFilter,
    overlaySearchVal,
    currentOverlayPageNo
  ]);

  // overflow set contents code ends here
  var tempTableData: any = [];
  var menuLists: any = [];
  var tempExportData: any = [];

  //Pinot table data
  useEffect(() => {
    final_data !== undefined && final_data !== null
      ? final_data?.map((val: any, i: any) => {
        permissions.includes("patchDetection_Fullaccess") || permissions.includes("all") ?
        tempTableData.push({
          checkbox: 'hide',
          key: i,
          patchname: { label: <Caption1> {val.ptitle} </Caption1> },
          patchtype: { label: <Caption1> {val.ptype} </Caption1> },
          patchdesc: { label: <Caption1> {val.patchdesc} </Caption1> },
          patchsize: { label: <Caption1> {(val.psize / 1024 / 1024).toFixed(2)} MB </Caption1> },
          machinecount: { label: <Button shape="circular" appearance="transparent" onClick={() => { handleMachineCountClick(val.ptitle); setOverlayOpen(true); }}>{val.patch_count}</Button> },
          releasedate: { label: <Caption1> {convertUTCToHumanReadableFormat(val.detectedate)} </Caption1> },
        })
        :
        tempTableData.push({
          checkbox: 'hide',
          key: i,
          patchname: { label: <Caption1> {val.ptitle} </Caption1> },
          patchtype: { label: <Caption1> {val.ptype} </Caption1> },
          patchdesc: { label: <Caption1> {val.patchdesc} </Caption1> },
          patchsize: { label: <Caption1> {(val.psize / 1024 / 1024).toFixed(2)} MB </Caption1> },
          machinecount: { label: <Button shape="circular" appearance="transparent" onClick={() => { handleMachineCountClick(val.ptitle); setOverlayOpen(true); }}>{val.patch_count}</Button> },
          releasedate: { label: <Caption1> {convertUTCToHumanReadableFormat(val.detectedate)} </Caption1> },
        })
      }) : (tempTableData = []);

    (tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]));

    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
    }, 500);

  }, [final_data]);

  var tempOverlayTableData: any = [];
  useEffect(() => {
    setOverlayTableData([]);
    tempOverlayTableData = [];

    final_overlay_data !== undefined && final_overlay_data !== null ? final_overlay_data?.map((val: any, i: any) => {
      tempOverlayTableData.push({
        checkbox: 'hide',
        key: i,
        host: { label: <Caption1> {val.host} </Caption1> },
        detectedDate: { label: <Caption1> {convertUTCToHumanReadableFormat(val.date)} </Caption1> },
      });
    }) : (tempOverlayTableData = []);

    (tempOverlayTableData.length > 0 ? setOverlayTableData(tempOverlayTableData) : setOverlayTableData([]));

    setTimeout(() => {
      final_overlay_data !== undefined && final_overlay_data !== null && setOverlayTableLoading(false);
    }, 500);

  }, [final_overlay_data]);


  useEffect(() => {
    // data table values append code ends here
    setOverLayData({
      headerTitle: "Machine details",
      size: "large",
      isTabs: false,
      tabItems: {

      },
      bodyData: (
        <>
          <FluentProvider theme={dashboardTheme}>
            <StackItem>
              <Stack wrap horizontal tokens={{ childrenGap: 20 }}>
              <StackItem><Text></Text></StackItem>
                <StackItem>
                  <SearchBar columnSearch={"for Device Name"} searchVal={overlaySearchVal} setSearchVal={setOverlaySearchVal} disabled={loading || overlayTableData.length === 0} />
                </StackItem>
                <StackItem>
                  <MenuDropdown open={filterMenuOpenOverlay} btn={
                    <MenuButton disabled={loading || overlayTableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpenOverlay(true)}>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <FilterAdd20Filled {...(loading || overlayTableData.length === 0 ? secondaryIcon : primaryIcon)} />
                        <Body1> Filter </Body1>
                      </Stack>
                    </MenuButton>
                  } itemVal={
                    <>
                      <Body1Strong> Add a Filter </Body1Strong>
                      <Divider />
                      <MenuList>
                        <Stack tokens={{ childrenGap: 5 }}>
                          <StackItem> <Text></Text> </StackItem>
                          <StackItem> <Caption1> Filter </Caption1> </StackItem>
                          <DropdownComponent optionData={overlayColumns} setDropDownValue={setDropDownValue1Overlay} dropDownvalue={dropDownValue1Overlay} />
                          <StackItem> <Divider /> </StackItem>
                          <StackItem> <Caption1> Value </Caption1> </StackItem>
                          {/* {dropDownValue1Overlay === "Operating System" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2Overlay} dropDownvalue={dropDownValue2Overlay} />} */}
                          {dropDownValue1Overlay === "Device Name" && <Input size='small' onChange={overlayInputChange} name="filter" value={dropDownValue2Overlay} />}
                          <StackItem>
                            <Divider />
                          </StackItem>
                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                            <StackItem>
                              <Button shape="circular" appearance="primary" onClick={() => { handleOverlayFilter(); setFilterMenuOpenOverlay(false) }}
                                disabled={dropDownValue2Overlay == undefined || dropDownValue2Overlay?.length === 0 || dropDownValue1Overlay == undefined || dropDownValue1Overlay?.length === 0 || filterArray.includes(`${dropDownValue1Overlay}:`) ? true : false}>
                                <Caption1> Apply </Caption1>
                              </Button>
                            </StackItem>
                            <StackItem>
                              <Button shape="circular" onClick={() => setFilterMenuOpenOverlay(false)}>
                                <Caption1> Cancel </Caption1>
                              </Button>
                            </StackItem>
                          </Stack>
                        </Stack>
                      </MenuList>
                    </>}
                  />
                </StackItem>
                <StackItem onClick={() => { setOverlayFilterArray([]); setIsOverlayFilter(false); setDropDownValue1Overlay(''); setResetDisabled(true); setOverlayTableLoading(true) }}>
                  <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <FilterDismiss20Filled /> </StackItem>
                      <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                    </Stack>
                  </Button>
                </StackItem>
              </Stack>
            </StackItem>
            <StackItem>
              {filterArray.length > 0 && filterArray.map((item, index) => (
                <Button shape="circular" size="small">
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> {item} </StackItem>
                    <StackItem>
                      <Stack tokens={{ childrenGap: 1 }}>
                        <StackItem><Text></Text></StackItem>
                        <StackItem><Dismiss16Regular onClick={() => { handleCloseOverlayFilter(index) }} /></StackItem>
                      </Stack>
                    </StackItem>
                  </Stack>
                </Button>
              ))}
            </StackItem>
            <Stack tokens={{ childrenGap: 10 }} >
              <StackItem>
                {overlayTableData.length > 0 && !overlayTableLoading && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                  <StackItem> {totalOverlayRecords > 0 && <Caption1>  Showing {((currentOverlayPageNo - 1) * 50) + 1} to {(currentOverlayPageNo * 50) > totalOverlayRecords ? totalOverlayRecords : (currentOverlayPageNo * 50)} of {totalOverlayRecords} Records </Caption1>} </StackItem>
                  <StackItem> <Pagination setLoading={setOverlayTableLoading} totalPages={totalOverlayPages} currentPageNo={currentOverlayPageNo} setCurrentPageNo={setCurrentOverlayPageNo} /> </StackItem>
                </Stack>
                }

              </StackItem>
              <StackItem>
                {overlayTableLoading ? (<SkeletonDataTable />) : overlayTableData.length > 0 ? (
                  <DataTable tableData={overlayTableData} columns={overlayColumns}></DataTable>
                ) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}

              </StackItem>
            </Stack>
          </FluentProvider>
        </>
      ),
    });
  }, [overlayTableData, overlayTableLoading, totalOverlayPages, currentOverlayPageNo, totalOverlayRecords, filterMenuOpenOverlay]);

  //console.log("tableData.length=======??", tableData.length);
  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
            <Stack tokens={{ childrenGap: 10 }} horizontal>
                <StackItem grow shrink>
                    <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                        <StackItem><Text></Text></StackItem>
                        <StackItem grow shrink>
                            <Breadcrumbs
                                items={[
                                    {name:"Manage", link:"/home" },
                                    {name:"Patch Management", link:"#"},
                                    {name:"Patch Detection", link:"#"},
                                ]} 
                            /> 
                        </StackItem>
                    </Stack>
                </StackItem>
            </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            <StackItem style={DynamicBoxingCSS}>
              <FluentProvider style={DynamicBoxingCSS} theme={dashboardTheme}>
                <Stack style={DynamicBoxingCSS}>
                  <Stack style={{ ...parentHome }} horizontal>
                    {/* SPACING BETWEEN INLINE AND PAGE */}
                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={PatchPages(`Patch${" "}Detection`)} />
                    <StackItem style={DynamicBoxingCSS}>
                      <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                        <StackItem>
                          <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                          <Divider />
                        </StackItem>
                        <StackItem>
                          <StackItem style={wraperStyle}>
                            <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                              {checkDart && <Stack horizontal tokens={{ childrenGap: 10 }}>
                                <StackItem>
                                  <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Patch Name"} searchVal={searchTerm} setSearchVal={setSearchTerm} setLoading={setLoading} disabled={loading || tableData?.length === 0} />
                                </StackItem>
                                <StackItem>
                                  <MenuDropdown open={filterMenuOpen} btn={
                                    <MenuButton disabled={loading || tableData?.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <FilterAdd20Filled {...(loading|| tableData?.length === 0?secondaryIcon:primaryIcon)} />
                                        <Body1> Filter </Body1>
                                      </Stack>
                                    </MenuButton>
                                  } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                    <Divider />
                                    <MenuList>
                                      <Stack tokens={{ childrenGap: 5 }}>
                                        <StackItem> <Text></Text> </StackItem>
                                        <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                        <DropdownComponent optionData={columns1} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />

                                        <StackItem> <Divider /> </StackItem>
                                        <StackItem> <Caption1> Value </Caption1> </StackItem>
                                        {(dropDownValue1 === "Patch Name") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                        {(dropDownValue1 === "Patch Type") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                        {(dropDownValue1 === "Release date") && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                        <StackItem> <Divider /> </StackItem>
                                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                                          <StackItem>
                                            <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                              disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                              <Caption1> Apply </Caption1>
                                            </Button>
                                          </StackItem>

                                          <StackItem>
                                            <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                              <Caption1> Cancel </Caption1>
                                            </Button>
                                          </StackItem>
                                        </Stack>
                                      </Stack>
                                    </MenuList>
                                  </>} />
                                </StackItem>
                                <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true) }}>
                                  <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem> <FilterDismiss20Filled /> </StackItem>
                                      <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                    </Stack>
                                  </Button>
                                </StackItem>
                              </Stack>}
                              {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                            </Stack>
                            {filterArray.length > 0 && <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                              <Stack wrap horizontal >
                                {filterArray.length > 0 && filterArray.map((item, index) => (
                                  <Button shape="circular" size="small">
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                      <StackItem>
                                        <Stack tokens={{ childrenGap: 1 }}>
                                          <StackItem><Text></Text></StackItem>
                                          <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                        </Stack>
                                      </StackItem>
                                    </Stack>
                                  </Button>
                                ))}
                              </Stack>
                            </Stack>}
                          </StackItem>
                          <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                          {tableData.length > 0 && !loading && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                            <StackItem> {totalRecords > 0 && <Caption1>  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records </Caption1>} </StackItem>
                          </Stack>}
                        </StackItem>
                        {loading ? (<SkeletonDataTable />) : tableData.length > 0 && checkDart ? (
                          <DataTable tableData={tableData} columns={columns}></DataTable>
                        ) : !checkDart ? <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>{dartErrorMessage}</Text></StackItem></Stack> : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                      </Stack>
                    </StackItem>
                  </Stack>
                  <OverLay
                    overlayopen={overlayOpen}
                    setOverlayOpen={setOverlayOpen}
                    overlayData={overLayData}
                  />
                </Stack>
              </FluentProvider>
            </StackItem>
          </StackItem>
          <StackItem><Text></Text></StackItem>
          {isToast && (
            <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent={message.type} position="top-end" title={message.type.charAt(0).toUpperCase() + message.type.slice(1)} message={message.text} footer="" />
          )}
          {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
        </Stack>
      </FullScreen>
    </>
  );
};

